import React, { useCallback, useState } from 'react';
import { Autocomplete } from '@shopify/polaris';
import { injectIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';

const typeToSearchOption = [
  { label: 'Type to search...', value: 'Type to search...' }
];

function AutoComplete(props) {
  const {
    intl,
    options: allOptions,
    handleChange,
    showAllOnEmpty = true
  } = props;
  const deselectedOptions = allOptions;
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState(
    showAllOnEmpty ? deselectedOptions : typeToSearchOption
  );

  const updateText = useCallback(
    (value) => {
      setInputValue(value);

      if (value === '' && !showAllOnEmpty) {
        setOptions(typeToSearchOption);
        return;
      }

      const filterRegex = new RegExp(value, 'i');
      let resultOptions = deselectedOptions.filter((option) =>
        option.label.match(filterRegex)
      );
      resultOptions =
        resultOptions.length === 0
          ? [{ label: 'No Result', value: 'No Result' }]
          : resultOptions;
      setOptions(resultOptions);
    },
    [deselectedOptions]
  );

  function resetField() {
    setSelectedOptions([]);
    setInputValue('');
    setOptions(showAllOnEmpty ? allOptions : typeToSearchOption);
  }

  const updateSelection = useCallback(
    (selected) => {
      if (selected[0] === 'No Result' || selected[0] === 'Type to search...') {
        resetField();
        return;
      }
      let selectedOption;
      options.map((option) => {
        if (option.value === selected[0]) {
          selectedOption = option;
        }
      });
      resetField();
      handleChange(selectedOption);
    },
    [options]
  );

  const textField = (
    <Autocomplete.TextField
      onChange={updateText}
      value={inputValue}
      placeholder={getTranslatedText(
        intl,
        'admin.Holidaymanagement.list.search'
      )}
    />
  );

  return (
    <div>
      <Autocomplete
        options={options}
        selected={selectedOptions}
        onSelect={updateSelection}
        textField={textField}
      />
    </div>
  );
}
export default injectIntl(AutoComplete);
